import apiClient from '../../shared/auth/services'

export const imageFolderService = {
  // Get image folder list including deleted folders
  async getImageFolderList(isContainDeleted = true) {
    const response = await apiClient.post('/getImageFolderList', {
      isContainDeleted
    })
    return response.data
  },

  // Add new image folders
  async addImageFolderList(newImageFolderList) {
    const data = {
      imageFolderList: newImageFolderList.map(folder => ({
        imageFolderId: folder.imageFolderId,
        imageFolderName: folder.imageFolderName,
        orderIndex: folder.orderIndex
      }))
    }
    const response = await apiClient.post('/addImageFolder', data)
    return response.data
  },

  // Update existing image folders
  async updateImageFolderList(updatedImageFolderList) {
    const data = {
      imageFolderList: updatedImageFolderList.map(folder => ({
        imageFolderId: folder.imageFolderId,
        imageFolderName: folder.imageFolderName,
        deleteFlg: folder.deleteFlg,
        orderIndex: folder.orderIndex
      }))
    }
    const response = await apiClient.post('/updateImageFolder', data)
    return response.data
  },

  // Remove image folders (mark as deleted)
  async removeImageFolderList(removedImageFolderList) {
    const data = {
      imageFolderList: removedImageFolderList.map(folder => ({
        imageFolderId: folder.imageFolderId
      }))
    }
    const response = await apiClient.post('/removeImageFolder', data)
    return response.data
  }
}

export default imageFolderService
